/*!
 * © 2024. The EGT Universe. All Rights Reserved.
 * License: Requires ACTIVE AppArtisan Subscription.
 * For more information visit: https://egtuniverse.com/legal
 *
 * Created for Universe App Tools.
 *
 * Created by Justin K Kazmierczak.
 */
var _ = require("../../../uam/module.js")(module.exports, {
    namespace: "email.text",
    title: "Email Text",
    description: "A body paragraph row for platform emails.",
    supportServer: true,
    control: false,
    foruseIn: ["email"],
    fields: {
        "content": {
            title: "Content",
            type: "string",
            description: "The paragraph text to display.",
            required: true
        }
    }
});
var $ = require("../../../uam/scafolding.js");

exports.render = async function (options) {
    var { html } = await exports.renderEmail(options);
    return [{
        n: "ua.element.serverNotSupported",
        inner: {
            n: "json",
            type: "ua/interface",
            by: "email.text",
            i: JSON.stringify({
                n: "html",
                html: `<div style="max-width:480px;margin:0 auto;font-family:Arial,Helvetica,sans-serif;">${html}</div>`
            })
        }
    }];
};

exports.renderEmail = async function (options) {
    var content = (options && options.content) ? options.content : "";
    var cfg = $.config || {};
    var text = (cfg.my && cfg.my.app && cfg.my.app.colors && cfg.my.app.colors.text) || "#000000";

    var html = `<tr>
  <td style="padding:8px 20px;font-family:Arial,Helvetica,sans-serif;font-size:16px;color:${text};line-height:1.6;">
    <p style="margin:0;padding:0;">${content}</p>
  </td>
</tr>`;

    var plainText = content;

    return { html, text: plainText };
};
